const TOKEN_KEY = 'zephir_access';
const REFRESH_KEY = 'zephir_refresh';
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefresh = () => localStorage.getItem(REFRESH_KEY);
export const setTokens = (access, refresh) => { localStorage.setItem(TOKEN_KEY, access); localStorage.setItem(REFRESH_KEY, refresh); };
export const clearTokens = () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(REFRESH_KEY); };
export const isAuthenticated = () => !!getToken();
